module.exports = __webpack_public_path__ + "img/tt.9574aff3.svg";